import { css } from '@emotion/core';

export const V4Styles = css`
  :root {
    --zds-colors-lava: #ff4a00;
    --zds-colors-lava-120: #d93f00;
    --zds-colors-lava-80: #ff6e33;
    --zds-colors-lava-60: #ff9266;
    --zds-colors-lava-40: #ffb799;
    --zds-colors-lava-20: #ffdbcc;
    --zds-colors-lava-10: #ffede6;
    --zds-colors-lava-5: #fff6f2;

    /* Ocean (blues) */
    --zds-colors-ocean: #136bf5;
    --zds-colors-ocean-120: #2655bd;
    --zds-colors-ocean-80: #4289f7;
    --zds-colors-ocean-60: #71a6f9;
    --zds-colors-ocean-40: #a1c4fb;
    --zds-colors-ocean-20: #d0e1fd;
    --zds-colors-ocean-10: #e7f0fe;
    --zds-colors-ocean-5: #f3f8ff;

    /* Sun (yellows) */
    --zds-colors-sun: #ffc43e;
    --zds-colors-sun-120: #e6b038;
    --zds-colors-sun-80: #ffd065;
    --zds-colors-sun-60: #ffdc8b;
    --zds-colors-sun-40: #ffe7b2;
    --zds-colors-sun-20: #fff3d8;
    --zds-colors-sun-10: #fff9ec;
    --zds-colors-sun-5: #fffcf5;

    /* Error */
    --zds-colors-error: #e02d00;
    --zds-colors-error-10: #ffe1d5;
    --zds-colors-error-120: #b92602;

    /* Warning */
    --zds-colors-warning: #ffc43e;
    --zds-colors-warning-10: #ffe7b2;

    /* Success */
    --zds-colors-success: #62d493;
    --zds-colors-success-10: #daf5e6;

    /* Grays */
    --zds-colors-gray: #333333;
    --zds-colors-gray-80: #424242;
    --zds-colors-gray-60: #757575;
    --zds-colors-gray-40: #cccccc;
    --zds-colors-gray-20: #e6e6e6;
    --zds-colors-gray-10: #f2f2f2;
    --zds-colors-gray-5: #fafafa;

    /* Typography */
    --zds-typography-base: 'Open Sans', sans-serif;
    --zds-typography-heading: 'Open Sans', sans-serif;
    --zds-typography-letter-spacing: -1px;
    --zds-typography-pageheader-weight: 800;
    --zds-typography-pageheader1-fontsize: 70px;
    --zds-typography-pageheader1-lineheight: 75px;
    --zds-typography-pageheader3-fontsize: 55px;
    --zds-typography-pageheader3-lineheight: 60px;
    --zds-typography-pageheader5-lineheight: 45px;
    --zds-typography-pageheader7-lineheight: 35px;
    --zds-typography-pageheader9-lineheight: 30px;
    --zds-typography-paragraph1short-lineheight: 25px;
    --zds-typography-paragraph3-lineheight: 25px;
  }
`;
